var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "g-nav" }, [
      _c("div", { staticClass: "n-nav" }, [
        _vm.noticeType
          ? _c("div", { staticClass: "notice" }, [
              _c(
                "div",
                {
                  staticClass: "noticeContent",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.hrefUrl($event)
                    }
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      "通知：祝新老客户五一节日快乐！假期平台下单功能不受影响，订单受理时间延迟至5月5日，给您带来的不便敬请谅解！紧急联系人--刘工：13421832556、0752-5283248"
                    )
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "closeNotice",
                    attrs: { src: require("./close.svg") },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.closeNotice($event)
                      }
                    }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "n-main-box", staticStyle: { position: "relative" } },
          [
            _c("div", { staticClass: "n-main" }, [
              _c("div", { staticClass: "n-left" }, [
                _c(
                  "a",
                  { staticClass: "n-logo", attrs: { href: _vm.url.domain } },
                  [
                    _c("img", {
                      attrs: { src: require("./logo.svg"), alt: "InZ应龙" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ul" }, [
                  _c("ul", [
                    _c(
                      "li",
                      {
                        staticClass: "icon-down",
                        attrs: { id: "trackEvent_indexBtn" },
                        on: { click: _vm.indexPage }
                      },
                      [_vm._v("首页")]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "icon-down",
                        on: {
                          mouseenter: function($event) {
                            _vm.enter(1)
                          },
                          mouseleave: _vm.leave
                        }
                      },
                      [
                        _vm._v("\n                  在线下单"),
                        _c("span", { staticClass: "fa fa-angle-down reg-d" }),
                        _vm._v(" "),
                        _vm.tabIndex == 1
                          ? _c(
                              "div",
                              { staticClass: "panel-main panel-item" },
                              [
                                _c("div", { staticClass: "p-main" }, [
                                  _c("div", { staticClass: "p-order" }, [
                                    _c("h3", [_vm._v("PCB+PCBA+BOM")]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "一站式在线估价&下单，可视化交付体验，专业柔性制造系统及供应链，满足客户个性化多样化的研发、生产需求。"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "p-btn",
                                        attrs: {
                                          href:
                                            _vm.url.orderDomain +
                                            "/index/inquire",
                                          id: "trackEvent_IDMGo"
                                        }
                                      },
                                      [_vm._v("立即下单")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "p-pcb idm-item",
                                      attrs: {
                                        rel: "nofollow",
                                        target: "_blank",
                                        href: _vm.url.orderDomain + "/index/PCB"
                                      }
                                    },
                                    [
                                      _c("h3", [_vm._v("PCB")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "高端特色PCB样板、快板；兼容少量多品种、中批量生产"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._m(0)
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "p-pcba idm-item",
                                      attrs: {
                                        target: "_blank",
                                        rel: "nofollow",
                                        href:
                                          _vm.url.orderDomain + "/index/PCBA"
                                      }
                                    },
                                    [
                                      _c("h3", [_vm._v("PCBA")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "高精密、智能硬件模块装联 大批量装联服务"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._m(1)
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "p-bom idm-item",
                                      attrs: {
                                        target: "_blank",
                                        rel: "nofollow",
                                        href: _vm.url.orderDomain + "/index/BOM"
                                      }
                                    },
                                    [
                                      _c("h3", [_vm._v("BOM")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "资深工程师全程服务、高品质BOM咨询服务"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._m(2)
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "icon-down",
                        on: {
                          mouseenter: function($event) {
                            _vm.enter(4)
                          },
                          mouseleave: _vm.leave
                        }
                      },
                      [
                        _vm._v("\n                  制造能力"),
                        _c("span", { staticClass: "fa fa-angle-down reg-d" }),
                        _vm._v(" "),
                        _vm.tabIndex == 4
                          ? _c("div", { staticClass: "pro-panel panel-item" }, [
                              _c("div", { staticClass: "pro-main" }, [
                                _c("div", { staticClass: "pro-left" }, [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "tab",
                                        _vm.tabFlag == 1 ? "active" : ""
                                      ],
                                      on: {
                                        mouseover: function($event) {
                                          _vm.tab(1)
                                        }
                                      }
                                    },
                                    [_vm._v("PCB生产制造")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "tab",
                                        _vm.tabFlag == 2 ? "active" : ""
                                      ],
                                      on: {
                                        mouseover: function($event) {
                                          _vm.tab(2)
                                        }
                                      }
                                    },
                                    [_vm._v("PCBA装联")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "tab",
                                        _vm.tabFlag == 3 ? "active" : ""
                                      ],
                                      on: {
                                        mouseover: function($event) {
                                          _vm.tab(3)
                                        }
                                      }
                                    },
                                    [_vm._v("BOM配齐")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "pro-right" }, [
                                  _vm.tabFlag == 1
                                    ? _c(
                                        "div",
                                        { staticClass: "content tab-c" },
                                        [
                                          _c("div", { staticClass: "r-main" }, [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  href:
                                                    _vm.url.domain +
                                                    "/technology/pcbCraftSecondary?type=1",
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/product_img_1.png"),
                                                    alt: "HDI板"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm._m(3)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  href:
                                                    _vm.url.domain +
                                                    "/technology/pcbCraftSecondary?type=2",
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/product_img_2.png"),
                                                    alt: "高多层板"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm._m(4)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  href:
                                                    _vm.url.domain +
                                                    "/technology/pcbCraftSecondary?type=4",
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/product_img_3.png"),
                                                    alt: "高频板"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm._m(5)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  href:
                                                    _vm.url.domain +
                                                    "/technology/pcbCraftSecondary?type=6",
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/product_img_4.png"),
                                                    alt: "金属基板"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm._m(6)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  href:
                                                    _vm.url.domain +
                                                    "/technology/pcbCraftSecondary?type=5",
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/product_img_5.png"),
                                                    alt: "厚铜电源板"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm._m(7)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  href:
                                                    _vm.url.domain +
                                                    "/technology/pcbCraftSecondary?type=3",
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/product_img_6.png"),
                                                    alt: "刚挠结合板"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm._m(8)
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "r-more" }, [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "a-more",
                                                attrs: {
                                                  href:
                                                    _vm.url.domain +
                                                    "/technology/pcbCraft"
                                                }
                                              },
                                              [_vm._v("了解更多")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "btn-more",
                                                attrs: {
                                                  rel: "nofollow",
                                                  href:
                                                    _vm.url.orderDomain +
                                                    "/index/PCB"
                                                }
                                              },
                                              [_vm._v("马上下单")]
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.tabFlag == 2
                                    ? _c(
                                        "div",
                                        { staticClass: "content tab-c" },
                                        [
                                          _c("div", { staticClass: "r-main" }, [
                                            _c(
                                              "div",
                                              { staticClass: "item-A" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/PCBA_icon_1.png")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("h3", [
                                                  _vm._v("SMT表面贴膜")
                                                ]),
                                                _vm._v(" "),
                                                _vm._m(9)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "item-A" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/PCBA_icon_2.png")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("h3", [_vm._v("THT通插装")]),
                                                _vm._v(" "),
                                                _vm._m(10)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "item-A" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/PCBA_icon_3.png")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("h3", [_vm._v("微组装")]),
                                                _vm._v(" "),
                                                _vm._m(11)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "item-A" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/PCBA_icon_4.png")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("h3", [
                                                  _vm._v("工业防护&可靠性测试")
                                                ]),
                                                _vm._v(" "),
                                                _vm._m(12)
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "r-more" }, [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "a-more",
                                                attrs: {
                                                  rel: "nofollow",
                                                  href:
                                                    _vm.url.domain +
                                                    "/technology/pcbACraft"
                                                }
                                              },
                                              [_vm._v("了解更多")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "btn-more",
                                                attrs: {
                                                  rel: "nofollow",
                                                  href:
                                                    _vm.url.orderDomain +
                                                    "/index/PCBA"
                                                }
                                              },
                                              [_vm._v("马上下单")]
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.tabFlag == 3
                                    ? _c(
                                        "div",
                                        { staticClass: "content tab-c" },
                                        [
                                          _c("div", { staticClass: "r-main" }, [
                                            _c(
                                              "div",
                                              { staticClass: "item-B item-A" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/BOM_icon_1.png")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("h3", [
                                                  _vm._v(
                                                    "大数据+资深工程师配齐"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm._m(13)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "item-B item-A" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/BOM_icon_2.png")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("h3", [
                                                  _vm._v("BOM自动匹配+成本预估")
                                                ]),
                                                _vm._v(" "),
                                                _vm._m(14)
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "item-B item-A" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("./img/BOM_icon_3.png")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("h3", [
                                                  _vm._v(
                                                    "研发、计划、成本核算服务"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm._m(15)
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "r-more" }, [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "a-more",
                                                attrs: {
                                                  href:
                                                    _vm.url.domain +
                                                    "/technology/pcbCraft"
                                                }
                                              },
                                              [_vm._v("了解更多")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "btn-more",
                                                attrs: {
                                                  href:
                                                    _vm.url.orderDomain +
                                                    "/index/inquire",
                                                  rel: "nofollow"
                                                }
                                              },
                                              [_vm._v("马上下单")]
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(16),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "icon-down",
                        on: {
                          mouseenter: function($event) {
                            _vm.enter(6)
                          },
                          mouseleave: _vm.leave
                        }
                      },
                      [
                        _vm._v("\n                  解决方案"),
                        _c("span", { staticClass: "fa fa-angle-down reg-d" }),
                        _vm._v(" "),
                        _vm.tabIndex == 6
                          ? _c("div", { staticClass: "pro-panel panel-item" }, [
                              _c(
                                "div",
                                { staticClass: "pro-main solve-main" },
                                [
                                  _vm._m(17),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "solve-right" }, [
                                    _c(
                                      "div",
                                      { staticClass: "content" },
                                      _vm._l(_vm.solveList, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "item-parent"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    "https://inzaowu.com" +
                                                    item.url,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "solve-item",
                                                    on: {
                                                      mouseenter: function(
                                                        $event
                                                      ) {
                                                        _vm.enterImg(index)
                                                      },
                                                      mouseleave: _vm.leaveImg
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          _vm.enterImgFlag ==
                                                          index
                                                            ? item.img2
                                                            : item.img1
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "item-title"
                                                      },
                                                      [_vm._v(_vm._s(item.h2))]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "icon-down",
                        attrs: { id: "trackEvent_indexBtn" },
                        on: { click: _vm.indexPageS }
                      },
                      [_vm._v("生态合作")]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "icon-down",
                        attrs: { id: "trackEvent_indexBtn" },
                        on: { click: _vm.indexPageUs }
                      },
                      [_vm._v("关于我们")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "n-right" }, [
                !_vm.userInfo
                  ? _c("div", { staticClass: "loginB" }, [
                      _c(
                        "a",
                        { staticClass: "reg-btn", on: { click: _vm.LoginC } },
                        [_vm._v("注册")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "login-btn",
                          attrs: { rel: "nofollow" },
                          on: { click: _vm.LoginC }
                        },
                        [_vm._v(" 登录")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.userInfo
                  ? _c(
                      "div",
                      {
                        staticClass: "info-n",
                        attrs: {
                          id: [
                            _vm.userInfo
                              ? "headerUserInfo"
                              : "headerUserInfoNone"
                          ]
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info",
                            on: {
                              mouseover: function($event) {
                                _vm.enterInfo("1")
                              },
                              mouseleave: _vm.leaveInfo
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "name",
                                attrs: {
                                  title: _vm.userInfo.realname,
                                  href: "javascript:void(0);"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  应用中心\n                  "
                                ),
                                _c("span", {
                                  staticClass: "fa fa-angle-down reg-d",
                                  staticStyle: {
                                    "text-indent": "0",
                                    "margin-left": "8px"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.InfoShow
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.loginOutLoading,
                                        expression: "loginOutLoading"
                                      }
                                    ],
                                    staticClass: "info-item"
                                  },
                                  [
                                    _vm._l(_vm.userRoleList, function(item) {
                                      return _c(
                                        "a",
                                        {
                                          key: item.platformType,
                                          staticClass: "item",
                                          attrs: {
                                            rel: "nofollow",
                                            href: "" + item.platformDomain,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: { src: item.url }
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item.platformName) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _vm.userRoleList.length == 0
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              rel: "nofollow",
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v("暂无应用")]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "userName-r",
                            on: {
                              mouseover: function($event) {
                                _vm.enterInfo("2")
                              },
                              mouseleave: _vm.leaveInfo
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "name",
                                attrs: {
                                  title: _vm.userInfo.realname,
                                  href: "javascript:void(0);"
                                }
                              },
                              [_vm._v(_vm._s(_vm.userInfo.realname))]
                            ),
                            _vm._v(" "),
                            _vm.InfoCenterShow
                              ? _c("div", { staticClass: "panenl-u-r" }, [
                                  _c(
                                    "div",
                                    { staticClass: "userInfo-item-t-r" },
                                    [
                                      _c("div", { staticClass: "img-info" }, [
                                        _vm._m(18),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "user-code-r" },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                "客户代码：" +
                                                  _vm._s(_vm.userInfo.workNo)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                "登录账号：" +
                                                  _vm._s(_vm.userInfo.realname)
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "outLogin" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          href: "javascript:void(0);",
                                          id: "loginOut"
                                        },
                                        on: { click: _vm.loginOutHandle }
                                      },
                                      [_vm._v("退出登录")]
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.bjNavFlag ? _c("div", { staticClass: "bj-nav" }) : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list" }, [
      _c("ul", [
        _c("li", [_vm._v("HDI板")]),
        _vm._v(" "),
        _c("li", [_vm._v("高频板")]),
        _vm._v(" "),
        _c("li", [_vm._v("高多层板")]),
        _vm._v(" "),
        _c("li", [_vm._v("金属基板")]),
        _vm._v(" "),
        _c("li", [_vm._v("刚挠结合板")]),
        _vm._v(" "),
        _c("li", [_vm._v("厚铜电源板")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list" }, [
      _c("ul", [
        _c("li", [_vm._v("SMT表面贴膜")]),
        _vm._v(" "),
        _c("li", [_vm._v("微组装")]),
        _vm._v(" "),
        _c("li", [_vm._v("THT通插装")]),
        _vm._v(" "),
        _c("li", [_vm._v("工业防护&可靠性测试")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list" }, [
      _c("ul", [
        _c("li", [_vm._v("大数据+资深工程师配齐")]),
        _vm._v(" "),
        _c("li", [_vm._v("BOM自动匹配+成本评估")]),
        _vm._v(" "),
        _c("li", [_vm._v("研发、计划、成本核算服务")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("HDI板")]),
      _vm._v(" "),
      _c("span", [_vm._v("8层 FR4 S1000-2 4.0mm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("高多层板")]),
      _vm._v(" "),
      _c("span", [_vm._v("8层 FR4 S1000-2 4.0mm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("高频板")]),
      _vm._v(" "),
      _c("span", [_vm._v("8层 FR4 S1000-2 4.0mm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("金属基板")]),
      _vm._v(" "),
      _c("span", [_vm._v("8层 4.0mm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("厚铜电源板")]),
      _vm._v(" "),
      _c("span", [_vm._v("8层 4.0mm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("刚挠结合板")]),
      _vm._v(" "),
      _c("span", [_vm._v("8层 4.0mm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n                                Surface Mounted"),
      _c("br"),
      _vm._v(
        "\n                                Technology\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n                                Through Hole "),
      _c("br"),
      _vm._v(
        "\n                                Technology\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n                                Microassembly "),
      _c("br"),
      _vm._v(
        "\n                                process\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n                                Industrial protection & "),
      _c("br"),
      _vm._v(
        "\n                                reliability testing\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-B" }, [
      _c("ul", [
        _c("li", [_vm._v("高效自动匹配 自研物料库")]),
        _vm._v(" "),
        _c("li", [_vm._v("优质原厂数据")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-B" }, [
      _c("ul", [
        _c("li", [_vm._v("现货采购")]),
        _vm._v(" "),
        _c("li", [_vm._v("工程师配齐")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-B" }, [
      _c("ul", [
        _c("li", [_vm._v("系统自动匹配")]),
        _vm._v(" "),
        _c("li", [_vm._v("精准数据对接 成本管理")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      { staticClass: "icon-down", attrs: { id: "trackEvent_indexBtn" } },
      [_c("a", { attrs: { href: "/cad" } }, [_vm._v("设计能力")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "solve-left" }, [
      _c("h3", { staticClass: "h3-text" }, [_vm._v("行业解决方案")]),
      _vm._v(" "),
      _c("p", { staticClass: "detail-text" }, [
        _vm._v(
          "InZ应龙面向不同行业和领域 的业务场景，提供从创意到产 品，生产到制造全链条硬件研 发解决方案，助力客户增效降 本，快速实现市场价值。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: {
          src:
            "http://cmsfile.kingbrother.com//f359626d0f84efdfc0f07e27bbfd5a02.jpg"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78fd42a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78fd42a3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/nav/nav.vue
// module id = null
// module chunks = 